import { ManageUnitsUnitView, PillUnit } from '@mark43/cad-api';

export function convertManageUnitsUnitViewToPillUnit(unit: ManageUnitsUnitView): PillUnit {
    return {
        callSign: unit.callSign.label,
        id: unit.id,
        unitStateGroup: unit.unitStateGroup,
        isPrimary: unit.isPrimary,
        staffCount: unit.staffCount,
        isAssignedToAnotherEvent: false,
        isHeld: false,
        isTemporary: false,
        unitStateId: 0,
        eventId: 0,
        unitStateDisplayValue: '',
        unitStatusUpdatedDateUtc: '',
    };
}
